export { allowedSaleTransitions, canCollectSalePayment } from '@klothiq/domain';
export const saleStatusLabel = (status: string) =>
  status.replaceAll('_', ' ').replace(/^./, (c) => c.toUpperCase());
